import { store } from '../../store/index'

export const changeComponentAuthorization = (text: string) => store.commit('updateComponent', text)
